import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-order\"><path d=\"M907.4 133.9H702V70.1H322v63.8H114.9v820H909.2v-820h-1.8zM362 110.1h300v120H362v-120z m507.2 803.8H154.8v-740H322v96.2h380v-96.2h167.2v740zM762 401v40H262v-40h500zM262 537.2h500v40H262v-40z m0 136.2h500v40H262v-40z\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order.svg
// module id = gYtG
// module chunks = 22